<template>
    <div class="panel-tag mb-0 pl-3 pr-3">
        <div class="row">
            <div class="col-4">
                Умови оплати (в тендері):
            </div>
            <div class="col-8">
                {{tender_payment}}
            </div>
        </div>
        
        <div class="row">
            <div class="col-4">
                Умови поставки (в тендері):
            </div>
            <div class="col-8">
                {{tender_delivery}}
            </div>
        </div>
        <div class="row">
            <div class="col-4">
                Строк поставки (в тендері):
            </div>
            <div class="col-8">
                {{tender?.date_delivery}}
            </div>
        </div>
        
        <div class="row">
            <div class="col-4">
                Оптимальна сума:
            </div>
            <div class="summ_opt col-8" >
                {{ this.formatUA(this.protocol.calculated_sum.opt_sum) }}
            </div>
        </div>
        <div class="row">
            <div class="col-4">
                Поточна сума:
            </div>
            <div class="summ_current col-8" value="0">
                {{ this.formatUA(this.protocol.calculated_sum.cur_sum)}}
            </div>
        </div>
        
    </div>
</template>

<script>
export default {
    name: "protocol_info_head",
    props : {
        protocol : {
            type : Object
        }
    },
    
    methods : {
        formatUA(num) {
            const n = Number(num) || 0
            return n.toFixed(2).replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 ') + ' грн.'
        },
    },
    
    computed : {
        tender() {
            return this.protocol?.tender;
        },
        
        tender_payment() {
            return this.tender?.payment_name;
        },
        
        tender_delivery() {
            return this.tender?.delivery_name;
        }
    },
}
</script>


<style scoped>

</style>